import React from "react";

/**
 * Estimator line-item row. Compose as a `<tr>` inside a `<Table>`.
 * @param {Object} props — line-item fields (cost_code, description, qty, uom,
 *   labor, material, equip, sub, waste_pct, markup_pct, extension).
 */
export function EstimatorLineRow({
  cost_code, description, qty, uom,
  labor = 0, material = 0, equip = 0, sub = 0,
  waste_pct = 0, markup_pct = 0, extension = 0,
}) {
  return (
    <tr>
      <td style={{ fontFamily: "var(--font-mono)" }}>{cost_code}</td>
      <td>{description}</td>
      <td className="num">{qty}</td>
      <td>{uom}</td>
      <td className="num">${labor.toLocaleString()}</td>
      <td className="num">${material.toLocaleString()}</td>
      <td className="num">${equip.toLocaleString()}</td>
      <td className="num">${sub.toLocaleString()}</td>
      <td className="num">{waste_pct}%</td>
      <td className="num">{markup_pct}%</td>
      <td className="num" style={{ color: "var(--color-primary)", fontWeight: 600 }}>
        ${extension.toLocaleString()}
      </td>
    </tr>
  );
}
